<div class="content">

    <div class="d-flex justify-content-start mt-4">
        <ng2-smart-table [settings]="settings" [source]="listCatalog" >
        </ng2-smart-table>
       


    </div>
    <div class="d-flex justify-content-center mt-2" *ngIf="viewLoadMoreCatalog()">
        <div (click)="loadMoreCatalogs()"
       style="cursor: pointer;">
        <div class="d-flex align-items-center">
            <i class="fa-solid fa-arrows-rotate"></i>
            <span>Load more catalogs</span>
        </div>
    </div>
        
    </div>

</div>